import * as actionTypes from '../actions/actionTypes'
import {updateObject} from '../../helpers/utilities'

const initialState = {
  brokers: [],
  loading: false,
  pagination: {
    current_page: 0,
    per_page: 25,
    total_pages: 1,
    total_count: 0
  },
  broker_notes: {},   // { [broker_name]: Note[] } — lazily filled on expand
  notes_loading: {}   // { [broker_name]: bool }
}

const fetchBrokersStart = (state, action) => {
  return updateObject(state, {loading: true, brokers: []})
}

const fetchBrokersSuccess = (state, action) => {
  return updateObject(state, {
    loading: false,
    brokers: action.brokers,
    pagination: action.pagination
  })
}

const fetchBrokersFail = (state, action) => {
  return updateObject(state, {loading: false})
}

const fetchBrokerNotesStart = (state, action) => {
  return updateObject(state, {
    notes_loading: {...state.notes_loading, [action.broker_name]: true}
  })
}

const fetchBrokerNotesSuccess = (state, action) => {
  return updateObject(state, {
    broker_notes: {...state.broker_notes, [action.broker_name]: action.notes},
    notes_loading: {...state.notes_loading, [action.broker_name]: false}
  })
}

const fetchBrokerNotesFail = (state, action) => {
  return updateObject(state, {
    notes_loading: {...state.notes_loading, [action.broker_name]: false}
  })
}

const reducer = (state = initialState, action) => {
  switch(action.type){
    case actionTypes.FETCH_BROKERS_START:
      return fetchBrokersStart(state, action)
    case actionTypes.FETCH_BROKERS_SUCCESS:
      return fetchBrokersSuccess(state, action)
    case actionTypes.FETCH_BROKERS_FAIL:
      return fetchBrokersFail(state, action)
    case actionTypes.FETCH_BROKER_NOTES_START:
      return fetchBrokerNotesStart(state, action)
    case actionTypes.FETCH_BROKER_NOTES_SUCCESS:
      return fetchBrokerNotesSuccess(state, action)
    case actionTypes.FETCH_BROKER_NOTES_FAIL:
      return fetchBrokerNotesFail(state, action)
    default:
      return state
  }
}

export default reducer
